export default "__VITE_ASSET__DRpjTJ6g__"